import type { InputProps } from "react-aria-components";

import React from "react";
import { Group } from "react-aria-components";

import { Button } from "@/components/button";
import { Input } from "@/components/field";
import { XIcon } from "@/components/icons";
import { composeTailwindRenderProps } from "@/components/utils";

interface NameInputProps extends InputProps {
  onClear?: () => void;
  showClearButton?: boolean;
}

export const NameInput = React.forwardRef<HTMLInputElement, NameInputProps>(
  function NameInput({ onClear, showClearButton, ...inputProps }, ref) {
    return (
      <Group
        className={[
          "isolate",
          "grid",
          "grid-cols-[1fr_calc(theme(size.6)+16px)]",
        ].join(" ")}
        data-ui="control"
      >
        <Input
          {...inputProps}
          className={composeTailwindRenderProps(inputProps.className, [
            "col-span-full",
            "row-start-1",
            showClearButton ? "pr-10" : "pr-4",
          ])}
          ref={ref}
        />

        {showClearButton && onClear && (
          <Button
            className="z-10 -col-end-1 row-start-1 place-self-center"
            isIconOnly
            onPress={onClear}
            size="sm"
            variant="plain"
          >
            <div className="flex items-center justify-center w-[26px] h-[26px] bg-bg-tertiary rounded-full hover:bg-bg-quaternary transition-colors">
              <XIcon
                aria-label="Clear name"
                className="w-[16px] h-[16px] text-text-tertiary scale-[0.80]"
              />
            </div>
          </Button>
        )}
      </Group>
    );
  },
);
